import React from 'react';

interface FilterInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  width?: number;
}

export function FilterInput({ value, onChange, placeholder = 'Filter List', width = 200 }: FilterInputProps) {
  return (
    <div className="input-group filter" style={{ width, marginLeft: 5, display: 'inline-table' }}>
      <span className="input-group-addon"><i className="fas fa-filter" aria-hidden="true" /></span>
      <input
        type="text"
        className="form-control"
        style={{ transition: 'background-color 500ms linear', ...(value ? { backgroundColor: 'rgb(252, 248, 227)', borderColor: 'rgb(192, 152, 83)' } : {}) }}
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
      />
      {value && (
        <span className="input-group-btn">
          <button className="btn btn-default" type="button" onClick={() => onChange('')}>
            <i className="fas fa-times" aria-hidden="true" />
          </button>
        </span>
      )}
    </div>
  );
}
